import { Form, Formik } from 'formik'
import React, { useState } from 'react'
import styles from '../report.module.scss';
import Select from 'components/Select';
import Button from 'components/Button/Button';
import { useDispatch } from 'react-redux';
import { editDiagnosticFindingNotesAction } from 're-ducks/report';
import { toast } from 'react-toastify';
import { removeEmpty } from 'utils/removeEmptyValues';
import { CreateFindingsNoteSchema } from 'utils/validation';
import FormLoader from 'components/Loading/FormLoader';


const EditDiagnosticNotes = ({ findingsNotes, currentFindings, setAddNewFindings, isFetchingNotes }) => {
 const dispatch = useDispatch();
 const [isLoadingNotes, setIsLoadingNotes] = useState("");

 const commaSeperatedValues = (data) => {
  return data?.split('\n')
  ?.filter(item => item.trim() !== '')
  ?.join(',');
}

 const handleSubmitDiagnosticNotes = (values, actions) => {
    const data = removeEmpty(values);
    const res =   {
      impression: commaSeperatedValues(values.impression)
    }
    const others = removeEmpty(res)
    setIsLoadingNotes(true);
    dispatch(
        editDiagnosticFindingNotesAction(
          {
            id: currentFindings?.[0]?.id,
            params: {
              ...data,
              ...others
            }
          },
          (res) => {
            setIsLoadingNotes(false);
            toast.success(res.message);
          },
          (err) => {
            setIsLoadingNotes(false);
            toast.error(err)
          }
        )
    )
 }

  return (
    <div>
        <Formik
          initialValues={{
            notes: findingsNotes?.[0]?.note ?? "",
            recommendation: findingsNotes?.[0]?.recommendation ?? "",
            impression: findingsNotes?.[0]?.impressions?.join('\n') ?? "",
            note_tied_to: currentFindings?.[0]?.report_type ?? "",
          }}
          enableReinitialize
          onSubmit={(values, actions) => {
            handleSubmitDiagnosticNotes(values, actions)
          }}
          validationSchema={CreateFindingsNoteSchema}
        >
            {(formik) => {
                return(
                  <div>
                    {isFetchingNotes ? <FormLoader style={{ width: "100%"}} /> : <Form>
                      <div className={styles.create_diagnostics__textarea}>
                        <p>Significant Findings</p>
                          <textarea
                            name="notes"
                            value={formik.values.notes}
                            onChange={formik.handleChange}
                          />
                            {formik.errors.notes ? (
                          <span className="error">{formik.errors.notes}</span>
                        ) : null}
                      </div>
                      <div className={styles.create_diagnostics__textarea}>
                        <p>Recommendation</p>
                          <textarea
                            name="recommendation"
                            value={formik.values.recommendation}
                            onChange={formik.handleChange}
                          />
                          {formik.errors.recommendation ? (
                          <span className="error">{formik.errors.recommendation}</span>
                        ) : null}
                      </div>
                      <div className={styles.create_diagnostics__textarea}>
                        <p>Impression</p>
                          <textarea
                            name="impression"
                            value={formik.values.impression}
                            onChange={formik.handleChange}
                          />
                           {formik.errors.impression ? (
                          <span className="error">{formik.errors.impression}</span>
                        ) : null}
                      </div>
                      <div className={styles.create_diagnostics__btn}>
                        <Button theme="primary" size="md" 
                        disabled={!formik.isValid || !formik.dirty} loading={isLoadingNotes} type="submit">
                            Submit
                            </Button>
                      </div>
                    </Form>}
                    </div>
                )
            }}
        </Formik>
    </div>
  )
}

export default EditDiagnosticNotes